export default (theme) => ({
    iframeContainer: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    iframe: {
        width: '100%',
        border: 'none',
        height: '100%',
        maxHeight: 900,
    },
    buttonsContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        maxWidth: '900px',
        marginTop: '20px',
        marginBottom: '12px',
    },
    button: {
        marginRight: 20,
    },
});
